import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from './../../redux/User/user.actions';
import Button from './../forms/Button';
import './styles.scss';

// import Logo from './../../assets/logo.png';

const mapState = ({ user }) => ({
  currentUser: user.currentUser
});

const Header = props => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(mapState);

  const signOut = () => {
    dispatch(signOutUserStart());
  };

  return (
    <header className="header">
      <div className="wrap">
        <div className="logo">
          <Link to="/">
            <img src={require('./2handslogo.png')} alt="LOGO"/>
          </Link>
        </div>

        <nav>
          <ul>
            <li>
              <Link to="/">
                Home
              </Link>
            </li>
            <li>
              <Link to="/search">
                PRODUCT
              </Link>
            </li>
          </ul>
        </nav>

        <div className="callToActions">

          {currentUser && (
            <ul>
              <li>
                <Link to="/admin">
                  <Button className="btn">
                    Post
                  </Button>
                </Link>
              </li>
              <li>
                <Link to="/dashboard">
                  SELLER
                </Link>
              </li>
              <li>
                <span onClick={() => signOut()}>
                  LogOut
                </span>
              </li>
            </ul>
          )}

          {!currentUser && (
            <ul>
              <li>
                <Link to="/login">
                  <Button className="btn">
                    Post
                  </Button>
                </Link>
              </li>
              <li>
                <Link to="/registration">
                  Register
              </Link>
              </li>
              <li>
                <Link to="/login">
                  Login
              </Link>
              </li>
            </ul>
          )}

        </div>
      </div>
    </header>
  );
};

Header.defaultProps = {
  currentUser: null
};

export default Header;
